<template>
  <div id="withdraw_payroll_search_order">
    <!-- 顶部导航栏 -->
    <van-nav-bar :title="$t('title.search_order')" placeholder safe-area-inset-top @click-left="onClickLeft" left-arrow />
    <!-- 订单状态 -->
    <van-col span="24" class="withdraw_payroll_search_order_val">
      <van-col span="22" offset="1">
        <van-search
            v-model="search_value"
            show-action
            shape="round"
            :placeholder="$t('column.order_id')"
            @search="onSearch"
        >
          <template #action>
            <div @click="onSearch">搜索</div>
          </template>
        </van-search>
      </van-col>
    </van-col>
    <van-col span="22" offset="1" class="withdraw_payroll_search_order_list">
      <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="$t('other.there_is_no_more')"
          :loading-text="$t('other.Loading')"
          @load="onLoad"
      >
        <van-cell v-for="(o,i) in list" :key="i" class="withdraw_payroll_search_order_list_cell">
          <!-- 订单金额 -->
          <van-col span="22" offset="1">
            <van-col span="24" class="amount-label">{{ $t('column.payment_amount') }}</van-col>
            <van-col span="24" class="amount-value">{{ o.currency_type_code }} {{ o.cash_amount }}</van-col>
            <van-col span="18" class="order-id">{{ $t('column.order_id') }}:  <span :id="o.order_id">{{ o.order_id }}</span> <img src="../assets/img/creator/creator_agency_fz.png" @click="copyId(o.order_id)" /> </van-col>
            <van-col span="6" class="amount-arrow">
              <img :src="o.payment_method_img"/>
            </van-col>
          </van-col>
          <!-- 收益分配 -->
          <van-col span="22" offset="1" class="order-item-border-top">
            <van-col span="8" class="reward-item">
              <van-col span="24" class="reward-label">{{ $t('column.total') }}</van-col>
              <van-col span="24" class="reward-value">
                <img src="../assets/img/coin9.png"/> {{ o.amount_sum }}
              </van-col>
            </van-col>
            <van-col span="8" class="reward-item">
              <van-col span="24" class="reward-label">{{ $t('other.profit')}}</van-col>
              <van-col span="24" class="reward-value">
                <img src="../assets/img/coin9.png"/> {{ o.received_amount }}
              </van-col>
            </van-col>
            <van-col span="8" class="reward-item">
              <van-col span="24" class="reward-label">{{ $t('column.official_reward') }}</van-col>
              <van-col span="24" class="reward-value">
                <img src="../assets/img/coin9.png"/> {{ o.official_amount }}
              </van-col>
            </van-col>
          </van-col>
          <!-- 倒计时和操作按钮 -->
          <van-col span="22" offset="1" class="order-actions">
            <van-col span="12" class="countdown-section">
              <van-icon name="clock-o" color="#ff9500" size="16"  v-if="o.countdown_time"/>
              <van-count-down :time="o.countdown_time"  v-if="o.countdown_time"/>
            </van-col>
            <van-col span="12" class="details-btn-section" v-if="o.status === '0'">
              <!--  审核     -->
              <van-button color="#939393" size="small" plain round @click="cancelOrder(o)">{{ $t('btn.cancel') }}</van-button>
              <van-button color="#FF61F5" size="small" plain round @click="approveOrder(o)">{{ $t('btn.approve') }}</van-button>
            </van-col>
            <van-col span="12" class="details-btn-section" v-else>
              <!-- 详情按钮 -->
              <van-button color="#FF61F5" size="small" plain round @click="detailsOrder(o)">{{ $t('column.details') }}</van-button>
            </van-col>
          </van-col>
        </van-cell>
      </van-list>
    </van-col>
  </div>
</template>

<script>
import Toast from 'vant/lib/toast'
import axios from "axios";
import { Dialog } from "vant";
export default {
  data() {
    return {
      search_value: '',
      list: [],
      loading: false,
      finished: false,
      page: 1
    }
  },
  created() {
    this.get_list()
  },
  methods: {
    onLoad() {
      // 异步更新数据
      if (this.page > 1) {
        this.get_list()
      }
    },
    get_list(){
      this.loading = true
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=payroll_seller&act=payroll_seller_order_list",{
        params:{
          uid: uid,
          token: token,
          status: -1,
          search_key: this.search_value,
          p: this.page
        }
      }).then(res =>{
        if(res.data.status ===1){
          this.loading = false;
          if (this.page === 1) {
            this.list = []
          }
          for (let j = 0; j < res.data.data.list.length; j++) {
            this.list.push(res.data.data.list[j])
          }
          //如果列表数据条数< 0，不再触发滚动加载
          if (res.data.data.list.length < 20) {
            this.finished = true
          }
          this.page ++
        }else{
          Toast(res.data.error)
        }
      })
    },
    onSearch(){
      this.page = 1
      this.list = []
      this.finished = false
      this.get_list()
    },
    onClickLeft() {
      this.$router.go(-1)
    },
    copyId(creator_user_id) {
      const element = document.getElementById(creator_user_id);
      if (!element) {
        Toast('error');
        return;
      }
      // 创建临时textarea元素用于复制
      const tempTextArea = document.createElement('textarea');
      tempTextArea.value = element.textContent || element.innerText;
      document.body.appendChild(tempTextArea);
      // 选择并复制文本
      tempTextArea.select();
      try {
        const successful = document.execCommand('copy');
        if (successful) {
          Toast(this.$t('column.copy_success'));
          // 添加复制成功效果
          if (this.currentButton) {
            this.currentButton.classList.remove('copied');
          }
          this.currentButton = event.currentTarget;
          this.currentButton.classList.add('copied');
          // 3秒后移除复制成功样式
          setTimeout(() => {
            if (this.currentButton) {
              this.currentButton.classList.remove('copied');
            }
          }, 3000);
        } else {
          Toast('copy error');
        }
      } catch (err) {
        Toast('copy error: ' + err);
      }
      // 移除临时元素
      document.body.removeChild(tempTextArea);
    },
    cancelOrder(o) {
      Dialog.confirm({
        title: this.$t('column.is_cancel_order'),
        confirmButtonColor: '#FF61F5',
        confirmButtonText: this.$t('btn.confirm'),
        cancelButtonText: this.$t('btn.cancel'),
      }).then(() => {
        const toast = this.$toast.loading({
          duration: 0, // 持续展示
          forbidClick: true,
          message: this.$t('other.Loading') + '...',
          className: 'custom-loading-toast' // 添加自定义类名
        });
        const uid = this.$route.query.uid
        const token = this.$route.query.token
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=payroll_seller&act=cancel_payment",{
          params:{
            uid: uid,
            token: token,
            order_id: o.order_id
          }
        }).then(res =>{
          toast.clear(); // 关闭加载提示
          if(res.data.status ===1){
            Toast({
              message: res.data.error,
              duration: 2000, // 持续2秒
              onClose: () => {
                // 这里写Toast关闭后要执行的方法
                this.page = 1
                this.list = []
                this.finished = false
                this.get_list()
              }
            })
          }else{
            Toast(res.data.error)
          }
        })
      })
    },
    approveOrder(o) {
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      this.$router.push({ path: '/approve_order', query: { uid: uid, token: token, order_id: o.order_id } });
    },
    detailsOrder(o) {
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      this.$router.push({ path: '/withdraw_payroll_order', query: { uid: uid, token: token, order_id: o.order_id } })
    }
  }
}
</script>
<style scoped></style>


// WEBPACK FOOTER //
// src/components/withdraw_payroll_search_order.vue